<template>
  <component
    :is="root ? 'button' : 'div'"
    class="menu-control ui-btn flex--col-center-center"
    @click.stop="handleClick"
    aria-label="Show the menu"
    :class="{
      'menu-control--root': root,
      'menu-control--fade': getShouldFade
    }"
  >
    <div
      id="bleach-menu-icon"
      class="menu-icon-placeholder"
      :class="{
        open: active
      }"
    >
      <template v-for="index in 3">
        <span
          :key="index"
          :style="{
            backgroundColor: uiColor
          }"
        ></span>
      </template>
    </div>
  </component>
</template>

<script>
import GTMAPI from "@/integration/GTMAPI"

import { mapState } from "vuex"

export default {
  props: {
    active: Boolean,
    uiColor: String,
    root: Boolean
  },

  methods: {
    handleClick(e) {
      if (!this.active) {
        GTMAPI.trackEvent("navigation.hamburger.clicked")
      }
      this.$emit("click", e)
    }
  },

  computed: {
    ...mapState("ui", ["navUiColour", "navActiveElement"]),

    getShouldFade() {
      return this.navActiveElement && this.navActiveElement !== "menu"
    }
  }
}
</script>

<style lang="scss">
$stroke-width: 1.5px;

.menu-control {
  position: relative;
  cursor: pointer;
  margin: 0 -8px;
  padding: 0 8px;
  pointer-events: all;
  transition: opacity 0.2s linear;

  &--root {
    * {
      opacity: 0;
    }
  }

  &--fade {
    opacity: 0.1;
  }
}

.menu-icon-placeholder {
  position: relative;
  // fill: getcolour(bleach_black);
  // mix-blend-mode: difference;
  height: 16px;
  width: 22px;

  @include media-breakpoint-up(md) {
    width: 24px;
    height: 18px;
  }
}

#bleach-menu-icon {
  position: relative;
  transform: rotate(0deg);
  cursor: pointer;
}

#bleach-menu-icon span {
  // backdrop-filter: grayscale(100%) blur(20px) contrast(200) invert(100%);
  display: block;
  position: absolute;
  height: $stroke-width;
  width: 100%;

  opacity: 1;
  left: 0;

  transform: rotate(0deg);

  transition: 0.3s ease-in-out;
}

#bleach-menu-icon span:nth-child(1) {
  top: 0px;
  transform-origin: center;
}

#bleach-menu-icon span:nth-child(2) {
  top: calc(50% - (#{$stroke-width} / 2));
  transform-origin: center;
}

#bleach-menu-icon span:nth-child(3) {
  bottom: 0px;
  transform-origin: center;
}

#bleach-menu-icon.open span:nth-child(1) {
  transform: rotate(135deg);
  transform-origin: center;
  top: calc(50% - (#{$stroke-width} / 2));
}

#bleach-menu-icon.open span:nth-child(2) {
  opacity: 0;
}

#bleach-menu-icon.open span:nth-child(3) {
  transform: rotate(-135deg);
  transform-origin: center;
  bottom: calc(50% - (#{$stroke-width} / 2));
}
</style>
